module.exports = __webpack_public_path__ + "static/dufner-cardiaca-f7c667e01feeb6e3b5a6f6b8794d9902.jpg";